import {
  PrequelContextProvider,
  PrequelHooksProvider,
  DestinationTableProvider,
} from 'modules/dataSync/contexts';
import { DataSyncModalContextProvider } from 'modules/dataSync/contexts/ModalContextProvider';
import { DataSyncModals } from 'modules/dataSync/components/DataSyncModals';
import { DataSyncPage } from './DataSyncPage';

export const DataSyncPages = () => {
  return (
    <PrequelHooksProvider>
      <PrequelContextProvider>
        <DestinationTableProvider>
          <DataSyncModalContextProvider>
            <DataSyncPage />
            <DataSyncModals />
          </DataSyncModalContextProvider>
        </DestinationTableProvider>
      </PrequelContextProvider>
    </PrequelHooksProvider>
  );
};
